/**
 * Peer pricing vs similar inventory (make/model/year band) — Carvana/CarMax-style "good deal" signal.
 */

function median(values) {
  if (!values.length) return null;
  const sorted = [...values].sort((a, b) => a - b);
  const mid = Math.floor(sorted.length / 2);
  return sorted.length % 2 ? sorted[mid] : (sorted[mid - 1] + sorted[mid]) / 2;
}

export function computeMarketComparison(car, allCars = []) {
  if (!car?.price || !Array.isArray(allCars) || allCars.length < 4) return null;

  const price = parseFloat(car.price);
  if (!Number.isFinite(price) || price <= 0) return null;

  const year = Number(car.year);
  const make = (car.make || '').trim().toLowerCase();
  const model = (car.model || '').trim().toLowerCase();
  if (!make || !model || !year) return null;

  const peers = allCars.filter((p) => {
    if (!p || p.id === car.id) return false;
    if (String(p.status || '').toLowerCase() === 'sold') return false;
    const pPrice = parseFloat(p.price);
    if (!Number.isFinite(pPrice) || pPrice <= 0) return false;
    if ((p.make || '').trim().toLowerCase() !== make) return false;
    if ((p.model || '').trim().toLowerCase() !== model) return false;
    const py = Number(p.year);
    return Number.isFinite(py) && Math.abs(py - year) <= 2;
  });

  if (peers.length < 3) return null;

  const peerPrices = peers.map((p) => parseFloat(p.price));
  const marketMedian = median(peerPrices);
  if (!marketMedian || marketMedian <= 0) return null;

  const diff = marketMedian - price;
  const pctBelow = Math.round((diff / marketMedian) * 100);
  const isGoodDeal = pctBelow >= 5;
  const isAboveMarket = pctBelow <= -5;

  return {
    marketMedian: Math.round(marketMedian),
    price: Math.round(price),
    pctBelow,
    peerCount: peers.length,
    isGoodDeal,
    isAboveMarket,
    savings: diff > 0 ? Math.round(diff) : 0,
  };
}
